import React, { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

const ShiftUserSelect = React.memo(({
  id,
  subAvail = [],
  currentUserId,
  same,
  currentShiftUsers = [],
  userIndex,
  onUserChanged,
  autoFocus = false,
  onBlur,
}) => {
  // 1. Memorizza l'oggetto selezionato per evitare .find() superflui
  const selectedValue = useMemo(() => {
    return subAvail.find((u) => u.anaUserId === currentUserId) || null;
  }, [subAvail, currentUserId]);

  // 2. Crea un Set O(1) con gli ID già assegnati al turno per ottimizzare la disabilitazione
  const disabledUserIds = useMemo(() => {
    const ids = new Set();
    currentShiftUsers.forEach((u, idx) => {
      if (idx !== userIndex && u.anaUserId) {
        ids.add(u.anaUserId);
      }
    });
    return ids;
  }, [currentShiftUsers, userIndex]);

  return (
    <Autocomplete
      id={id}
      options={subAvail}
      openOnFocus
      autoHighlight
      getOptionLabel={(option) => option.nameSurname || ""}
      isOptionEqualToValue={(option, value) => option.anaUserId === value.anaUserId}
      value={selectedValue}
      onChange={(event, newValue) => {
        onUserChanged({
          element: { id },
          value: newValue ? newValue.anaUserId : null,
        });
      }}
      onBlur={onBlur}
      // Controllo istantaneo O(1) invece di Array.some() O(N)
      getOptionDisabled={(option) => disabledUserIds.has(option.anaUserId)}
      size="small"
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          placeholder="..."
          variant="outlined"
          margin="none"
          sx={{
            backgroundColor: same ? "#ABEBC6" : "#ffffff",
            borderRadius: "4px",
            "& .MuiOutlinedInput-root": {
              height: "32px",
              fontSize: "0.875rem",
              padding: "0 8px !important",
            },
            "& .MuiOutlinedInput-input": {
              fontWeight: same ? "bold" : "normal",
              padding: "0 !important",
            },
          }}
        />
      )}
    />
  );
});

export default ShiftUserSelect;